<template>
  <v-container fluid grid-list-md style="padding: 20px;">
    <v-row>
      <v-col cols="12" sm="12" md="6">
        <v-select
          outlined
          dense
          hide-details
          label="Selecione a situação para visualizar"
          v-model="situacaoSelecionada"
          :items="situacoes"
          @input="carregaDados"
        ></v-select>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <v-data-table
          :search="tabela.busca"
          :headers="tabela.cabecalho"
          :items="tabela.conteudo"
          sort-by="titulo"
          class="elevation-1"
          style="border-radius: 10px;"
          :footer-props="{
            'items-per-page-text': 'Linhas por página',
            'items-per-page-all-text': 'Tudo',
          }"
        >
          <template v-slot:top>
            <v-toolbar flat color="white" style="border-radius: 10px;">
              <v-toolbar-title class="textoUser">RESGATES</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field v-model="tabela.busca" append-icon="search" label="Procurar" single-line hide-details></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :disabled="item.situacao == 'CONCLUÍDO' || item.situacao == 'REJEITADO'">
                  <v-icon @click="aprovarSolicitacao(item)" color="green">mdi-check</v-icon>
                </v-btn>
              </template>
              <span>Aprovar Solicitação</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" :disabled="item.situacao == 'CONCLUÍDO' || item.situacao == 'REJEITADO'">
                  <v-icon @click="abreDialogoMotivo(item)" color="red">mdi-cancel</v-icon>
                </v-btn>
              </template>
              <span>Rejeitar Solicitação</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <v-btn color="#94AAB4" @click="carregaDados">Recarregar</v-btn>
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <v-chip v-if="item.situacao == 'CONCLUÍDO'" color="green" dark>{{ item.situacao }}</v-chip>
            <v-chip v-if="item.situacao == 'EM ANÁLISE'" color="orange" dark>{{ item.situacao }}</v-chip>
            <v-chip v-if="item.situacao == 'REJEITADO'" color="red" dark>{{ item.situacao }}</v-chip>
          </template>
          <template v-slot:[`item.valorResgate`]="{ item }">
            <p style="margin: 0px">R$ {{ item.valorResgate }}</p>
          </template>
          <template v-slot:[`item.valorDisponivel`]="{ item }">
            <p style="margin: 0px">R$ {{ item.valorDisponivel }}</p>
          </template>
          <template v-slot:[`item.created`]="{ item }">
            <p style="margin: 0px">{{ retornaData(item.created, 'DD/MM/YYYY') }} às {{ retornaData(item.created, 'HH:mm:ss') }}</p>
          </template>
          <template v-slot:[`item.dataConclusao`]="{ item }">
            <p style="margin: 0px" v-if="item.dataConclusao">{{ retornaData(item.dataConclusao, 'DD/MM/YYYY') }} às {{ retornaData(item.dataConclusao, 'HH:mm:ss') }}</p>
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogoMotivoRejeicao" max width="600px" persistent>
      <v-card>
        <v-card-title>Rejeitar resgate</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-textarea
                outlined
                hide-details
                label="Informe o motivo da rejeição"
                v-model="motivoRejeicao"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogoMotivoRejeicao = false" color="primary">Fechar</v-btn>
          <v-btn text @click="recusarSolicitacao" color="primary">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar ref=chamaSnackbar />
    <loading :active.sync="isLoading" :can-cancel="true" color="#3BA8A2" :is-full-page="fullPage"></loading>
  </v-container>
</template>

<script>
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import moment from 'moment'
  export default {
    components: { Snackbar, Loading, },
    data: () => ({
      isLoading: false,
      fullPage: true,
      tabela: {
        busca: '',
        cabecalho: [
          { text: 'Nome', align: 'start', value: 'nomeConsumidor', },
          { text: 'Tipo de Chave Pix', value: 'tipoChavePix' },
          { text: 'Chave Pix', value: 'chavePix' },
          { text: 'Favorecido', value: 'favorecidoPix' },
          { text: 'Valor do Resgate', value: 'valorResgate' },
          { text: 'Valor Disponível', value: 'valorDisponivel' },
          { text: 'Situação', value: 'situacao' },
          { text: 'Data Solicitação', value: 'created' },
          { text: 'Data Conclusão', value: 'dataConclusao' },
          { text: 'Motivo', value: 'motivoRejeicao' },
          { text: 'Ações', value: 'action', sortable: false },
        ],
        conteudo: [],
      },
      situacaoSelecionada: 'EM ANÁLISE',
      situacoes: ['CONCLUÍDO', 'EM ANÁLISE', 'REJEITADO'],
      idSolicitacao: '',
      dialogoMotivoRejeicao: false,
      motivoRejeicao: '',
    }),

    computed: mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
      formTitle () {
        return this.editedIndex === -1 ? 'Adicionar novo lojista' : 'Editar lojista'
      },
    }),

    watch: {
      dialogoMotivoRejeicao(val) {
        if (val == false) {
          setTimeout(() => {
            this.idSolicitacao = ''
            this.motivoRejeicao = ''
          }, 300);
        }
      },
    },

    mounted() {
      this.carregaDados()
    },

    methods: {
      async carregaDados () {
        this.isLoading = true
        this.tabela.conteudo = []
        await axios.post(baseApiUrl + 'SolicitacoesResgates/resgatesPorSituacao?access_token=' + sessionStorage.getItem('accToken'), {"situacao": this.situacaoSelecionada})
        .then(response => {
          if (response.data.length > 0) {
            this.tabela.conteudo = response.data
          }
        })
        this.isLoading = false
      },

      async aprovarSolicitacao (item) {
        var r = confirm('Concluir solicitação de resgate no valor de R$' + item.valorResgate + ' para ' + item.nomeConsumidor + '?')
        if (r == true) {
          await axios.post(baseApiUrl + 'SolicitacoesResgates/realizarSolicitacao?access_token=' + sessionStorage.getItem('accToken'), {"consumidorId": item.consumidorId})
          .then(() => {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaDados()
          })
        }
      },

      abreDialogoMotivo(item) {
        this.idSolicitacao = item.id
        this.dialogoMotivoRejeicao = true
      },

      async recusarSolicitacao() {
        var vm = this;

        if (this.motivoRejeicao) {
          this.isLoading = true

          await axios.patch(baseApiUrl + 'SolicitacoesResgates/' + this.idSolicitacao + '?access_token=' + sessionStorage.getItem('accToken'), {"situacao": "REJEITADO", "motivoRejeicao": this.motivoRejeicao, "dataConclusao": moment().toISOString()})
          .then(() => {
            vm.$refs.chamaSnackbar.snack("green", "Operação realizada com sucesso!", "SUCESSO")
            this.carregaDados()
            this.dialogoMotivoRejeicao = false
            this.isLoading = false
          })
        } else {
          vm.$refs.chamaSnackbar.snack("orange", "Informe o motivo da rejeição", "ATENÇÃO")
        }
      },

      retornaData(data, tipo) {
        return moment(data).format(tipo)
      },
    },
  }
</script>

<style>
  .textoUser {
    font-weight: bold;
    color: #424f4e;
    font-size: 17px;
  }

  @font-face {
    font-family: Roboto;
    src: url('https://fonts.google.com/specimen/Roboto');
  }

  .cssBotao {
    font-weight: bold;
    border-radius: 8px; width: 150px;
    font-size: 7px;
  }

  .theme--light.v-data-table thead tr th {
    color: white;
  }
  
  span.v-stepper__step__step.primary {
    background-color: #009B99!important;
    border-color: #009b9b!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #009B99;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #009B99;
  }
</style>
